import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';
import { getRestaurant } from '@/lib/api.ts';
import type { RestaurantResponseData } from '@/lib/types.ts';

// Booking-link pages (accept, confirmation) need the full restaurant — features and
// venue_map_url — which the reservation payload omits. Returns null while loading and
// ignores a stale response when restaurantId/token changes or the component unmounts.
export function useRestaurantDetail(
  restaurantId: number | null,
  token: string | null
): RestaurantResponseData | null {
  const [restaurant, setRestaurant] = useState<RestaurantResponseData | null>(null);

  useEffect(() => {
    // Clear stale details before each lookup so a previous restaurant's
    // venue_map_url / features can't apply to a newly loaded reservation.
    setRestaurant(null);
    if (!restaurantId) return;

    let cancelled = false;
    const date = new Date().toISOString().slice(0, 10);

    getRestaurant(restaurantId, date, '0:00', 'directlink', token)
      .then((res) => {
        if (!cancelled) setRestaurant(res?.data ?? null);
      })
      .catch((e: unknown) => {
        if (!cancelled) Sentry.captureException(e);
      });

    return () => {
      cancelled = true;
    };
  }, [restaurantId, token]);

  return restaurant;
}
